import { useContext } from 'react';
import classes from "./SearchOptions.module.css";

import { SearchContext } from '../../../App'; 
import ActivityResults from "./results/ActivityResults";
import DateResults from "./results/DateResults";
import LocationResults from "./results/LocationResults";

export const SearchOptions = () => {
  const { activeInput } = useContext(SearchContext);

  return (
    <>
      {activeInput !== null && (
        <div className={`SearchOptions_resultsContainer__M6hDA ${classes.resultsContainer}`}>
          {activeInput === 'activity' && <ActivityResults />}
          {activeInput === 'location' && <LocationResults />}
          {activeInput === 'date' && <DateResults />}
        </div>
      )}
    </>
  );
};

export default SearchOptions;